/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metrics_Show_DurationInputs */



/**
* | output |
* | --- |
* | "Show Duration" |
*
* @param {Options_Metrics_Show_DurationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metrics_show_duration = /** @type {((inputs?: Options_Metrics_Show_DurationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metrics_Show_DurationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Show Duration")
	if (locale === "de") return /** @type {LocalizedString} */ ("Show Duration")
	if (locale === "it") return /** @type {LocalizedString} */ ("Show Duration")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Show Duration")
	if (locale === "es") return /** @type {LocalizedString} */ ("Show Duration")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Show Duration")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Show Duration")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Show Duration")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Show Duration")
	return /** @type {LocalizedString} */ ("Show Duration")
});